module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Book-open-7c640d392a0168c54d6848a12dd92a59.svg";